// ─────────────────────────────────────────────────────────────────
// A "gate" component. Wrap any page with this and only
// logged-in users can enter. Everyone else is sent to /auth.
// ─────────────────────────────────────────────────────────────────

import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

function RequireUser({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // While we are still checking if a session exists, show nothing.
  // This prevents a brief "flash" where the user sees the login page
  // even though they are already logged in.
  if (loading) {
    return (
      <div className="routeGuard__spinner">
        <span className="routeGuard__dot" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Remember where the user was trying to go.
    // After they log in, we can send them straight back there.
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // User is logged in — show the actual page
  return children;
}

export default RequireUser;